













import { listFactory } from '@/main/pages/listFactory';
import * as _ from 'lodash';
import { apiProvider as ServiceJobProvider } from '@/modules/servis/serviceJob/api';
import { UserRole } from '@/main/components/constants';
import { NAME } from './constants';
import { showAlert } from '@/main/utils/notifications';
import { store } from './store/list';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';

export default listFactory(NAME, store).extend({
	methods: {
		createClick() {
			if (this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() !== UserRole.ADMIN) {
				showAlert({
					message: this.LocalizeChyboveHlasky('CantInsert'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			openEdit(NAME, PageMode.CREATE, { filter: { ServiceJobId: this.ServiceJobId } });
		},
		async editClick(event: any) {
			let canEdit = await ServiceJobProvider.CanEditOrDeleteServiceJob(event.data.SERVICE_JOB_ID);
			if (this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.ADMIN && canEdit.data) {
				openEdit(NAME, PageMode.EDIT, { id: event.data.SERVICE_JOB_ID });
			}
			else{
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
				
		},
	},
});
